import type { UseUtils } from "@/composables/useUtils";
import type { UseApiStore } from "@/stores/api";
import type { UseFormStore } from "@/stores/form";
import type { RouteLocationNormalized } from "vue-router";

export async function checkInsuranceAndRedirect(
  to: RouteLocationNormalized,
  util: UseUtils,
  api: UseApiStore,
): Promise<{ name: string } | undefined> {
  const insuranceCode = api.insuranceCode;
  const exemptRoutes = ["home", "resume", "end", "help"];
  const isExemptFromChecklistRedirect = exemptRoutes.includes(to.name as string);
  const needsInsuranceCode = to.meta?.needsInsuranceCode;

  if (insuranceCode) {
    let goToEnd = false;

    const checklist = await api.getChecklist();
    const isAllComplete = checklist.isAllComplete;

    if (isAllComplete && !isExemptFromChecklistRedirect) {
      util.log("All steps are complete. Redirecting to end page.");
      goToEnd = true;
    }

    if (goToEnd) return { name: "end" };
  } else if (needsInsuranceCode) {
    util.log("No insurance code found. Redirecting to home page.");

    return { name: "home" };
  }
}

export function checkMobileAccess(
  to: RouteLocationNormalized,
  util: UseUtils,
): { name: string } | false {
  const isDev = util.isDevelopment;
  const isDevRoute = to.meta?.isDevRoute;
  const isAllowedInDesktop = to.meta?.isAllowedInDesktop;
  const shouldCheckMobile = to.query?.checkMobile === "true";

  if (isDev && isDevRoute) {
    return false;
  }
  let mobileCheckEnabled = true;
  if (isDev && !shouldCheckMobile) {
    mobileCheckEnabled = false;
  }
  if (mobileCheckEnabled && !isAllowedInDesktop && !util.isMobile) {
    return { name: "desktop" };
  }
  return false;
}

export function checkBikePossession(
  to: RouteLocationNormalized,
  form: UseFormStore,
): { name: string } | false {
  const needsBike = to.meta.needsBike;
  if (needsBike && !form.hasBike) {
    return { name: "bikePossession" };
  }
  return false;
}
